module.exports = __webpack_public_path__ + "files/4e4e059ce6e1b9e146a1cd9ce41b9259.svg";